import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

import { useThemeStore } from '@/shared/ui/theme/theme.store';

export function Toaster(props: ToasterProps) {
  const theme = useThemeStore((s) => s.theme);
  return (
    <SonnerToaster
      theme={theme}
      richColors
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast rounded-[12px] group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border',
        },
      }}
      {...props}
    />
  );
}
